// noinspection JSUnusedGlobalSymbols
export enum SalutationType {
  MR = "Herr",
  MRS = "Frau",
  NONE = "Keine Anrede",
  OTHER = "Sonstige",
}

export const SALUTATION_TYPES = Object.values(SalutationType);
